module.exports = __webpack_public_path__ + "img/free-days.edf5c0c9.svg";